import { useState, useContext, useEffect } from 'react';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';
import Head from '@view/compoents/head/head'
import Loading from '@view/compoents/loading/loading'
import { AppContext } from '@utils/AppContext';
import Utils from '@utils/utils'
import dayjs from 'dayjs';
import styles from './index.module.scss'
import eventBus from '@utils/eventBus';

export default function PcLayout() {
    const location = useLocation();
    const { globalMemberList } = useContext(AppContext);

    const [daysMessage, setDaysMessage] = useState('')

    useEffect(() => {
        if (Utils.isMobileDevice()) return
        const html = document.querySelector('html')
        html.style.setProperty('--min-font-size', '50px');
        html.style.setProperty('--max-font-size', '999px');
        html.style.setProperty('--base-width', '1920');
    }, [])

    // 套餐即将过期提醒
    const checkPackageIsExpireSoon = (list) => {
        const html = document.querySelector('html')
        const today = dayjs(new Date()).format('YYYY-MM-DD')
        for (let item of list) {
            const expiredTime = dayjs(item.expiredTime)
            const diff = expiredTime.diff(today, 'day')
            if (diff <= 7 && diff >= 0) {
                const key = `${item.membershipId}_${expiredTime.valueOf()}`
                const keyStr = 'not_show_again_plan_expire_soon_' + key
                const notShowAgain_powerExpiredTime = localStorage.getItem(keyStr)
                if (notShowAgain_powerExpiredTime != '1') {
                    const daysMessage = diff > 0 ?
                        `您当前订阅的套餐将在${diff}天后过期，现在续订，剩余虹豆可延长到下期使用` :
                        `您当前订阅的套餐即将结束，现在续订，剩余虹豆可延长到下期使用`
                    setDaysMessage(daysMessage)
                    html.style.setProperty('--header-height', '50px');
                    // const alertMessage = `温馨提示：您购买的${item.subject}套餐当前服务周期${daysMessage}，请尽快续费以继续享受会员权益~`
                }
            }
        }
    }

    useEffect(() => {
        checkPackageIsExpireSoon(globalMemberList.filter(item => item.status == '0' && !!item.expiredTime && item.planType == 0)) // 0-套餐
    }, [globalMemberList])

    const payClick = () => {
        eventBus.emit('recharge')
        const html = document.querySelector('html')
        html.style.setProperty('--header-height', '0px');
    }

    return (
        <div style={{ height: '100%' }}>
            <div style={{
                height: 'var(--header-height)',
                backgroundColor: '#006EFF',
                color: '#fff',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                fontSize: '14px',
                transition: 'all 0.3s ease-in-out'
            }}>
                <>
                    {daysMessage}
                    {
                        daysMessage && <span
                            onClick={payClick}
                            className={styles.renewBtn}>立即续订</span>
                    }
                </>
            </div>
            <Head />
            <Outlet />
        </div>
    )
}